import { Text } from '@mantine/core';
import { useCallback, useMemo } from 'react';

import { nodeTypes } from '../constants/Facebook';
import useSelectableOptions from '../helpers/useSelectableOptions';

import SearchableCombobox from './SearchableCombobox';
import Spinner from './Spinner';

const OptionsSelect = ({ name, endpoint, handleChange, text, value, required = true, disabled }) => {
  const [options, isLoading, error] = useSelectableOptions(endpoint);

  const selectData = useMemo(
    () => [
      { value: '', label: `Please select ${nodeTypes[name] || ''}` },
      ...(options?.map((option) => ({
        value: String(name === 'adPayer' || name === 'adBeneficiary' ? option.name : option.id),
        label: option.name,
      })) || []),
    ],
    [options, name],
  );

  const handleSelectChange = useCallback(
    (val) => handleChange({ target: { name: `${name}Id`, value: val } }),
    [handleChange, name],
  );

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <SearchableCombobox
        options={selectData}
        value={value}
        onChange={handleSelectChange}
        disabled={error || disabled}
        error={!!error}
        emptyMessage="No options found"
      />
      {error && (
        <Text size="sm" c="red">
          {error.message}
        </Text>
      )}
      {text && (
        <Text size="sm" c="dimmed">
          {text}
        </Text>
      )}
    </>
  );
};

export default OptionsSelect;
